<template>
  <div>
    <FbMemberHeader
      :type="type"
      :member="profile" />
    <v-row no-gutters v-if="isRandom">
      <v-spacer />
      <v-btn color="primary" @click="copySeed">
        <v-icon left>mdi-clipboard</v-icon> Copy seed
      </v-btn>
      <v-btn color="primary" class="ml-2" @click="materialize" disabled>
        <v-icon left>mdi-atom</v-icon> Materialize
      </v-btn>
      <v-spacer />
    </v-row>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="2000"
    >
      {{ snackbar.text }}
    </v-snackbar>
    <v-container class="mb-10">
      <v-form>
        <!-- BASIC INFO -->
        <h1 class="caption text-uppercase">Basic Info</h1>
        <v-row wrap>
          <v-col cols="12" sm="6" lg="4">
            <v-text-field
              v-model.trim="profile.firstName"
              label="First name"
              filled
              required
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-text-field
              v-model.trim="profile.lastName"
              label="Last name"
              filled
              required
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-menu
              v-model="modal"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="profile.birthdate"
                  label="Birthdate"
                  readonly
                  filled
                  hide-details
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="profile.birthdate" @input="modal = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-select
              v-model="relationshipStatus"
              :items="relStatuses"
              label="Relationship status"
              filled
              hide-details
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-text-field
              v-model.number="profile.friendCount"
              label="Friends"
              type="number"
              filled
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-checkbox
              v-model="profile.isFriend"
              label="Friend"
              class="ma-0 mt-1 pa-0"
              hide-details
            ></v-checkbox>
            <v-checkbox
              v-model="profile.showBirthdate"
              label="Show birthday"
              class="ma-0 mt-1 pa-0"
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="12">
            <v-textarea
              v-model="profile.bio"
              filled
              label="Bio"
              counter="500"
              required
            ></v-textarea>
          </v-col>
        </v-row>
        <!-- PICTURES -->
        <FbMemberPictureGroup :member="profile" />
      </v-form>
    </v-container>
  </div>
</template>

<script>
import copy from 'copy-to-clipboard'

import FbMemberHeader from '../components/FbMemberHeader'
import FbMemberPictureGroup from '../components/FbMemberPictureGroup'

import { FbMember } from '../constants'
import { vueObjectAssign } from '../utils'
import { randomProfile } from '../random-fb-profile'

export default {
  name: 'FbProfile',
  injectModels: ['Store'],
  components: {
    FbMemberHeader,
    FbMemberPictureGroup
  },
  created() {
    this.id = this.$route.params.id
    this.profile = this.Store.fb.profiles[this.id]

    if (this.isRandom && this.profile == null) {
      const seed = this.id.substr(5)
      const profile = randomProfile(seed)

      this.$set(this.Store.fb.profiles, this.id, profile)
      this.profile = profile

      this.snackbar = {
        show: true,
        text: 'Added to Randoms'
      }
    }

    vueObjectAssign(this.profile, {
      firstName: '',
      lastName: '',
      profilePicture: undefined,
      coverPicture: undefined,
      featurePictures: [],
      birthdate: '2000-01-01',
      bio: undefined,
      showBirthdate: false,
      relationshipStatus: 0,
      friendCount: 0,
      isFriend: false
    })
  },
  data() {
    return {
      id: '',
      profile: {},
      type: FbMember.Profile,
      modal: false,
      relStatuses: [
        'None', 'Single', 'Taken', 'It\'s complicated',
        'Engaged', 'Married', 'Separated', 'Divorced', 'Widowed'
      ],
      snackbar: {
        show: false,
        text: ''
      }
    }
  },
  computed: {
    relationshipStatus: {
      get() {
        return this.relStatuses[this.profile.relationshipStatus]
      },
      set(value) {
        this.profile.relationshipStatus = this.relStatuses.indexOf(value)
      }
    },
    isRandom() {
      return this.id.startsWith('RAND_')
    },
    seed() {
      return this.isRandom ? this.id.substr(5) : ''
    }
  },
  methods: {
    copySeed() {
      if (this.isRandom) {
        copy(this.seed)
        this.snackbar = {
          show: true,
          text: 'Copied to clipboard'
        }
      }
    },
    materialize() {
      // TODO not yet ready
      if (!this.isRandom)
        return
      const id = `R_${this.seed}`
      this.$set(this.Store.fb.profiles, id, { ...this.profile })
      this.$router.replace(`/fb-profiles/${id}`)
    }
  }
}
</script>
